import * as React from 'react';
import { ImageContext, sizeConfig } from './ImageContext.esm.js';

var useImageConfig = function () {
    var size = React.useContext(ImageContext).size;
    return sizeConfig[size];
};

export { useImageConfig };
//# sourceMappingURL=useImageConfig.esm.js.map
